$(document).ready(function() {
    var geoIpProcessor = new GeoIpProcessor();
    geoIpProcessor.bindCancel("#j-geo-redirection-cancel");
    geoIpProcessor.bindRedirect("#j-geo-redirection-redirect");
    geoIpProcessor.init();
});

function GeoIpProcessor() {
    this.COOKIE = "GEOIP_COUNTRY_REDIRECT_REFUSED";
    this.popupController = "/geoip-country-popup";
}

GeoIpProcessor.prototype = {
    constructor: GeoIpProcessor,

    init: function() {
        var self = this;
        if (this.isHomepage()) {
            if (!this.isAlreadyRefused()) {
                $.ajax({
                    url: this.popupController,
                    success: function(data) { self.show(data); }
                });
            }
        }
    },

    bindCancel: function(selector) {
        var self = this;
        $(document).on("click", selector, function() {
            self.cancel();
        });
    },

    bindRedirect: function(selector) {
        var self = this;
        $(document).on("click", selector, function() {
            self.redirect($(this).data("url"));
        });
    },

    redirect: function(url) {
        $(location).attr('href', url);
    },

    cancel: function() {
        $.fancybox.close();
    },

    show: function(data) {
        var self = this;
        if (data.length <= 0) {
            return;
        }

        $.fancybox({
            content: data,
            maxWidth: 550,
            maxHeight: 130,
            autoSize: false,
            afterClose: function() { self.saveRefusal(); }
        });
    },

    saveRefusal: function() {
        $.cookie(this.COOKIE, true);
    },

    isHomepage: function() {
        return window.location.pathname === "/";
    },

    isAlreadyRefused: function() {
        return !!$.cookie(this.COOKIE);
    }
};
